import styled from 'styled-components';

export const StyledWorksheetActivity = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .iframe {
    width: 100%;
    flex: 1;
    border-radius: 8px;
    border: none;
    outline: none;

    &.ios {
      width: auto;
      height: 100%;
    }
  }

  &.fullscreen {
    .iframe {
      border-radius: 0;
    }
  }
`;
